// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9a4644ba","136":"6ccde957","563":"0749e107","576":"44f53628","618":"e28c0819","756":"d161effb"}[chunkId] + ".chunk.js";
};